import React, { useEffect, useState } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";

import api from "../../services/api";

const TicketsClientTagsSelect = ({ selectedTagIds = [], onChange }) => {
	const [tags, setTags] = useState([]);

	useEffect(() => {
		(async () => {
			try {
				const { data } = await api.get("/client-tags");
				setTags(Array.isArray(data) ? data : []);
			} catch {
				/* silencioso */
			}
		})();
	}, []);

	return (
		<div style={{ minWidth: 0, width: "100%" }}>
			<FormControl fullWidth margin="dense">
				<Select
					multiple
					displayEmpty
					variant="outlined"
					value={selectedTagIds}
					onChange={e => onChange(e.target.value)}
					MenuProps={{
						anchorOrigin: { vertical: "bottom", horizontal: "left" },
						transformOrigin: { vertical: "top", horizontal: "left" },
						getContentAnchorEl: null,
					}}
					renderValue={() =>
						selectedTagIds.length > 0
							? `Tags (${selectedTagIds.length})`
							: "Tags"
					}
				>
					{tags.map(t => (
						<MenuItem dense key={t.id} value={t.id}>
							<Checkbox
								style={{ color: t.color || undefined }}
								size="small"
								color="primary"
								checked={selectedTagIds.indexOf(t.id) > -1}
							/>
							<ListItemText primary={t.name} />
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
};

export default TicketsClientTagsSelect;
